import './LoginPage.scss';
import Component from './LoginPage.js';
export default Component;
